export default "__VITE_ASSET__BS2nyhtd__"